
import {Component, Emit, Prop, Vue} from 'vue-property-decorator';

@Component({name: 'DatePicker'})
export default class DatePicker extends Vue {
  isOpen: boolean = false;

  @Prop()
  label!: string;

  @Prop()
  value!: string | Date | null;

  @Prop()
  rules!: [];

  @Prop()
  type!: string;

  @Emit('input')
  onDateSelect(value: string) {
    this.isOpen = false;
    return value;
  }

  // formatDate (date: Date): string {
  //   if (!date) return null
  //
  //   const [year, month, day] = date.split('-')
  //   return `${month}/${day}/${year}`
  // }
}
